import { useState, useEffect } from "react";
import "./salaCard.css";

const SalaCard = ({ title, description, images }) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <article className="sala-card">

      {/* TEXTO ARRIBA */}
      <div className="sala-card__content">
        <h2>{title}</h2>
        <p>{description}</p>
      </div>

      {/* IMAGEN */}
      <div className="sala-card__image">
        <img src={images[current]} alt={title} />
      </div>

      {/* INDICADORES */}
      <div className="sala-card__dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={index === current ? "dot active" : "dot"}
            onClick={() => setCurrent(index)}
          />
        ))}
      </div>

    </article>
  );
};

export default SalaCard;
